import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from "react-bootstrap";

type Subject = {
  subject: string;
  values: Record<string, number>;
  evaluations: any[];
  average: number | null;
};

type Props = {
  show: boolean;
  onClose: () => void;
  selectedSubject: Subject | null;
};

const NoteDetailsModal = ({ show, onClose, selectedSubject }: Props) => {
  //Initialisation de l'année academmique actuelle
  if (!selectedSubject) return null; // ← rien afficher si pas de subject

  return (
    <>
      <Modal show={show} onHide={() => onClose()} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedSubject.subject}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Évaluation</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {selectedSubject.evaluations.map((ev: any) => {
                // Si pas de note, on n'affiche rien
                if (selectedSubject?.values[ev.id] == null) return null;

                return (
                  <tr key={ev.id}>
                    <td>{ev.label}</td>
                    <td>{Number(selectedSubject.values[ev.id]).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="mt-3 text-end">
            <strong>Moyenne finale :</strong>{" "}
            {selectedSubject?.average?.toFixed(2) ?? "-"}{" "}
            {selectedSubject?.average != null && (
              <span
                className={`badge fs-11 ${
                  selectedSubject.average >= 10
                    ? "badge-soft-success"
                    : "badge-soft-danger"
                }`}
              >
                {selectedSubject.average >= 10 ? "Validé" : "Non validé"}
              </span>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger me-3"
            onClick={() => {
              onClose();
            }}
          >
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NoteDetailsModal;
